import { request } from '../../utils/request';

export const getInventoryAnalytics = (
  store_id: number,
  authToken: string,
  filters?: Record<string, any>
) => {
  const filter = new URLSearchParams({
    ...filters,
    store_id: `${store_id}`,
  });
  return request({
    method: 'GET',
    url: `/products/inventory/metrics?${filter.toString()}`,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
};
